import Swiper from 'swiper/dist/js/swiper.js';
import owd from 'owd/owd';

export default class AwardsSlider extends owd.Component {
	init() {
		this.count = this.$element.find('.award').length;
		this.curr = 1;

        if (window.matchMedia('(max-width: 767px)').matches) {
            setTimeout(() => {
                this.prepareDom();
                this.createSlider();
            });
        }
	}

	prepareDom() {
        this.$element.append('<div class="swiper-container"><div class="swiper-wrapper"></div><div class="swiper-pagination"></div></div>');
        this.$element.find('.swiper-wrapper').append(this.$element.find('.award'));
        this.$element.find('.award').addClass('swiper-slide').each((index, item) => {
            $(item).attr('data-slide-number', index);
        });
		
		this.$swiperContainer = this.$element.find('.swiper-container');
	}

	getOptions() {
		return {
            speed: 500,
            nested: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            }
        };
	}

	createSlider() {
		let options = this.getOptions();

		this.swiper = new Swiper(this.$swiperContainer[0], options);

		this.$element.data('swiperInstance', this.swiper);
		this.$element.trigger('sliderInitialized', this.swiper);
	}

	destroy() {
		super.destroy();

		if (this.slider) {
			this.swiper.destroy();
		}
	}
}

owd.registerComponent('awards-slider', {
	component: AwardsSlider
});
